<template>
    <div v-redirect-if-no-permission:SERVICES>
        <v-dialog lazy :value="!!extraChargesServiceId" @input="extraChargesServiceId = null">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    {{ $t("settings.prices.extraCharges") }}
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <DataTable
                            v-if="extraChargesServiceId"
                            :url="api.ACTIONS.SERVICE_EXTRA_CHARGES(extraChargesServiceId)"
                            :enable-edit="false"
                            :fields-extra-add="fieldsExtraAddExtraCharges"
                            :titles="titlesExtraCharges"
                            :fields-hidden-add="['id','created_at','updated_at','deleted_at','service_price_id']"
                            :fields-hidden-main="['service_price_id','updated_at']"
                            :add-rules="rulesExtraCharge"
                            :formatter="formatterExtraCharges"
                            :input-types-add="{to_date: {clearable: true},
                            area_id: {multi :false},
                            apply_area_on: {items: ['PICKUP','PULLDOWN','BOTH'],clearable: true},
                            type : {items: ['CASH','PERCENTAGE' ],clearable: true},
                             }"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
        <DataTable
                v-if="name" :url="api.ACTIONS.SERVICE_PRICES(id)"
                disableSearch
                descending
                :titles="titles"
                :fieldsHiddenMain="['updated_at','service_id']"
                :title="$t('settings.prices.namePrices', { name })"
                force-reload
                :actions-extra-main="actionsExtraMain"
                :conditional-action="conditionalActions"
                :enableEdit="false"
                :enableDelete="false"
                :formatter="formatter"
                :fieldsExtraAdd="fieldsExtraAdd"
                :fieldsHiddenAdd="['updated_at','created_at','id','service_id','deleted_at']"
                :rowCallBack="rowCallBack"
                :add-rules="rules(true)"
                :edit-rules="rules(false)"
        ></DataTable>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import i18n from "@/i18n";

    const number = value => {
        const pattern = /^\d+(\.\d+)?$/;
        return pattern.test(value) || i18n.t("settings.prices.mustBeNumber");
    };
    const required = value => !!value || i18n.t('settings.prices.required');
    export default {
        name: "ServicePrices",
        title() {
            return this.$t('settings.prices.title');
        },
        components: {DataTable},
        data() {
            return {
                id: null,
                name: null,
                rowCallBack: (item) => {
                    if (!item.deleted_at) return ["active-price"];
                    return [];
                },
                extraChargesServiceId: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || this.$t("settings.prices.unknown");
        },
        methods: {
            rules(add) {
                return {
                    base_fare: add ? [
                        required, number
                    ] : [number],
                    waiting_cost_per_min: add ? [
                        required, number
                    ] : [number],
                    booking_cost_per_min: add ? [
                        required, number
                    ] : [number],
                    booking_distance_per_km: add ? [
                        required, number
                    ] : [number],
                    long_distance_cost_per_km: add ? [
                        required, number
                    ] : [number],
                    booking_fee: add ? [
                        required, number
                    ] : [number],
                    passenger_penalty: add ? [
                        required, number
                    ] : [number]
                }
            },
        },
        computed: {
            formatterExtraCharges() {
                const na = this.$t("settings.prices.notAvailable");
                return {
                    to_date(val) {
                        if (!val)
                            return na;
                        return val
                    },
                    area_id(val, item) {
                        if (!val)
                            return na;
                        return item.area.title
                    },
                    deleted_at(val) {
                        if (!val)
                            return na;
                        return val;
                    },
                    apply_area_on(val) {
                        if (!val)
                            return na;
                        return val;
                    }
                    // to_date(val) {
                    //     if (!val)
                    //         return "N\\A";
                    //     return val
                    // },       to_date(val) {
                    //     if (!val)
                    //         return "N\\A";
                    //     return val
                    // },
                }
            },
            actionsExtraMain() {
                return {
                    extraCharges: {
                        title: this.$t("settings.prices.extraCharges"),
                        color: "primary",
                        action: (item) => {
                            this.extraChargesServiceId = item.id
                        }
                    }
                }
            },
            conditionalActions() {
                return {
                    extraCharges: item => item.deleted_at === null
                }
            },
            titles() {
                return {
                    "id": "#",
                    "deleted_at": this.$t("settings.prices.endedAt"),
                    "created_at": this.$t("settings.prices.startedAt"),
                    'base_fare': this.$t("settings.prices.baseFare"),
                    'waiting_cost_per_min': this.$t("settings.prices.waitingCostPerMinute"),
                    "booking_cost_per_min": this.$t("settings.prices.bookingCostPerMinute"),
                    "booking_cost_per_km": this.$t("settings.prices.bookingCostPerKm"),
                    "long_distance_cost_per_km": this.$t("settings.prices.longDistanceCostPerKm"),
                    "minimum_charge": this.$t("settings.prices.minimumCharge"),
                    "booking_fee": this.$t("settings.prices.bookingFee"),
                    "passenger_penalty": this.$t("settings.prices.passengerPenalty")
                }
            },
            formatter() {
                const active = this.$t("settings.prices.active");
                return {
                    deleted_at(value) {
                        if (value == null) return active;
                        else return value;
                    },
                    base_fare(value) {
                        return JSON.stringify(value);
                    },
                    waiting_cost_per_min(value) {
                        return JSON.stringify(value);
                    },
                    booking_cost_per_min(value) {
                        return JSON.stringify(value);
                    },
                    booking_cost_per_km(value) {
                        return JSON.stringify(value);
                    },
                    long_distance_cost_per_km(value) {
                        return JSON.stringify(value);
                    }
                }
            },
            fieldsExtraAdd() {
                return {
                    "base_fare": "v-text-field",
                    "waiting_cost_per_min": "v-text-field",
                    "booking_cost_per_min": "v-text-field",
                    "booking_cost_per_km": "v-text-field",
                    "minimum_charge": "v-text-field",
                    "long_distance_cost_per_km": "v-text-field",
                    "booking_fee": "v-text-field",
                    "passenger_penalty": "v-text-field"
                }
            },
            fieldsExtraAddExtraCharges() {
                return {
                    from_date: "choose-date",
                    to_date: "choose-date",
                    from_time: "choose-time",
                    to_time: "choose-time",
                    amount: "v-text-field",
                    apply_area_on: "v-select",
                    area_id: "choose-locations",
                    type: "v-select"
                }
            },
            titlesExtraCharges() {
                return {
                    id: "#",
                    from_date: this.$t("settings.prices.fromDate"),
                    to_date: this.$t("settings.prices.toDate"),
                    from_time: this.$t("settings.prices.fromTime"),
                    to_time: this.$t("settings.prices.toTime"),
                    type: this.$t("settings.prices.type"),
                    amount: this.$t("settings.prices.amount"),
                    area_id: this.$t("settings.prices.area"),
                    apply_area_on: this.$t("settings.prices.areaConstraint"),
                    created_at: this.$t("settings.prices.creationDate"),
                    deleted_at: this.$t("settings.prices.deleteDate")
                }
            },
            rulesExtraCharge() {
                return {
                    from_date: [val => !!val || this.$t("common.required")],
                    from_time: [val => !!val || this.$t("common.required")],
                    to_time: [val => !!val || this.$t("common.required")],
                    amount: [val => !!val || this.$t("common.required")],
                    type: [val => !!val || this.$t("common.required")],

                }
            }
        }
    }
</script>

<style>
    .active-price {
        background: lightgreen;
    }
</style>
